import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ProductSchemaComponent } from './product-schema/product-schema.component';
import { InStoreComponent } from './in-store/in-store.component';
import { CompaniesComponent } from './companies/companies.component';
import { FrontlineTeamsComponent } from './frontline-teams/frontline-teams.component';
import { VqBannerComponent } from './vq-banner/vq-banner.component';
import { IndustriesComponent } from './industries/industries.component';
import { ExpertiseComponent } from './expertise/expertise.component';
import { SubscribeComponent } from '../subscribe/subscribe.component';
import { TestimonialsComponent } from './testimonials/testimonials.component';
import { TryDemoComponent } from '../try-demo/try-demo.component';

@Component({
  selector: 'app-main-page',
  templateUrl: './main-page.component.html',
  styleUrls: ['./main-page.component.scss'],
  imports: [
    InStoreComponent,
    CompaniesComponent,
    FrontlineTeamsComponent,
    VqBannerComponent,
    ProductSchemaComponent,
    IndustriesComponent,
    ExpertiseComponent,
    SubscribeComponent,
    TestimonialsComponent,
    TryDemoComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MainPageComponent {}
